/**
 * Bestaetigung ohne Popup (ADR 0025).
 *
 * Nach dem ersten Tipp fragt derselbe Knopf „Wirklich …?“, erst der zweite
 * Tipp setzt. Die Regeln stehen hier, damit sie ohne Oberflaeche pruefbar
 * sind -- der Knopf selbst ist `ui/StatusWahl.tsx`.
 */

/** So lange fragt der Knopf, dann ist er wieder wie vorher. */
export const FRAGE_MS = 5_000;

/**
 * Ein zweiter Tipp so kurz nach dem ersten zaehlt nicht. Sonst bestaetigt ein
 * Doppeltipp -- oder ein Handschuh, der zweimal aufkommt -- aus Versehen.
 */
export const SPERRE_MS = 500;

/** Welcher Knopf gerade fragt, und seit wann. */
export interface Frage {
  schluessel: string;
  seit: number;
}

export type Schritt =
  | { tun: "setzen" }
  | { tun: "fragen"; frage: Frage }
  /** Zu schnell nach dem ersten Tipp: nichts tun, weiter fragen. */
  | { tun: "warten" };

/** Was ein Tipp auf `schluessel` bewirkt. */
export function tippen(
  frage: Frage | null,
  schluessel: string,
  mitBestaetigung: boolean,
  jetzt: number,
): Schritt {
  if (!mitBestaetigung) return { tun: "setzen" };
  if (frage?.schluessel === schluessel) {
    const vergangen = jetzt - frage.seit;
    if (vergangen < SPERRE_MS) return { tun: "warten" };
    if (vergangen <= FRAGE_MS) return { tun: "setzen" };
  }
  return { tun: "fragen", frage: { schluessel, seit: jetzt } };
}

/** „Wirklich ‚Archiviert‘ setzen?“ -- in der Mehrfachauswahl mit der Anzahl. */
export function frageText(bezeichnung: string, anzahl?: number): string {
  if (anzahl === undefined) return `Wirklich „${bezeichnung}“ setzen?`;
  return `Wirklich „${bezeichnung}“ für ${String(anzahl)} ${anzahl === 1 ? "Gerät" : "Geräte"}?`;
}
